module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlePage"
  }, [_c('a', {
    attrs: {
      "id": "title24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tp-author"
  }, [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EMMA DARCY")])])]), _vm._v(" "), _c('div', {
    staticClass: "tp-title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Sheikh’s Seduction")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781459262102_i0002.jpg",
      "src": "e9781459262102_i0002.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("TORONTO • NEW YORK • LONDON "), _c('br'), _vm._v("AMSTERDAM • PARIS • SYDNEY • HAMBURG "), _c('br'), _vm._v("STOCKHOLM • ATHENS • TOKYO • MILAN "), _c('br'), _vm._v("MADRID • WARSAW • BUDAPEST • AUCKLAND")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b97e75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781459262102_tp01.vue
// module id = 66
// module chunks = 0